import React, { useState, useEffect } from 'react';
import { Treebeard, decorators } from 'react-treebeard';
import { includes } from 'lodash';
import { Header } from '../components'
import { Controlled as CodeMirror } from 'react-codemirror2'
import { ToastContainer, toast } from 'react-toastify';
import Page from 'react-page-loading'
import _ from 'lodash';
import API from '../api';
import 'react-toastify/dist/ReactToastify.css';
require('../../node_modules/codemirror/lib/codemirror.css');
require('../../node_modules/codemirror/theme/monokai.css');
require('../../node_modules/codemirror/mode/javascript/javascript');

const Editor = (props) => {
    const [cursor, setCursor] = useState(false);
    const [trees, setTrees] = useState({});
    const [projects, setProjects] = useState({});
    const [content, setContent] = useState('Select any project or file...');
    const params = new URLSearchParams(props.location.search);

    useEffect(() => {
        let isMounted = true;
        const querys = params.get('path') ? `?name=${params.get('path')}` : '';

        API.get(`getTree${querys}`, {mode: 'cors'})
            .then(res => {
                if (res.data && isMounted) {
                    setTrees(res.data)
                }
            })

        API.get('projects')
            .then(res => {
                if (res.data && isMounted) {
                    setProjects(res.data)
                }
            })
        return () => { isMounted = false };
        // eslint-disable-next-line
    }, [])

    const alertToast = (text, type = 'warn') => {
        toast[type](text, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    const onToggle = (node, toggled) => {
        if (cursor) {
            cursor.active = false;
        }

        node.active = true;

        if (node.children) {
            node.toggled = toggled;
        }

        setCursor(node);
        setTrees(Object.assign({}, trees))

        if (node.type === "file") {
            API.get(`source?path=${node.path}`)
                .then(res => {
                    if (res.data) {
                        setContent(res.data)
                    }
                })
        }
    }

    const onSelect = (node) => {
        if (cursor) {
            cursor.active = false;

            this.setState(() => ({ cursor, active: false }));

            if (!includes(cursor.children, node)) {
                node.toggled = false;
                node.selected = false;
            }
        }

        node.selected = true;
        setCursor(node);
        setTrees(Object.assign({}, trees))
    }

    const viewPage = (e) => {
        e.preventDefault()

        if (!cursor && !params.get('path')) {
            alertToast("Please select a project!")
        } else {
            const projectName = params.get('path') || cursor.path.split('/')[1]
            const activedItem = _.find(projects, (o) => o.path === projectName)
            if (!_.isEmpty(activedItem)) {
                var url = activedItem.link;
                var win = window.open(url, '_blank');
                win.focus();
            } else {
                alertToast("Permission error or Domain was changed!", "error")
            }
        }
    }

    const goBack = (e) => {
        e.preventDefault()
        window.history.back()
    }

    if (_.isEmpty(trees)) return "Sorry, Server error. try it later!"
    return (
        <div className="codeeditor-section area-bg">
            <Page loader={"rotate-spin"} color={"#A9A9A9"} size={6} duration={4}>
                <div className="project-header">
                    <h3 className="project-title">
                        <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                    &nbsp;
                    {
                            cursor ? cursor.name : "Projects"
                        }
                    </h3>
                    <span className="action-bars">
                        <a className="action-button" href="/" onClick={viewPage}><i className="fa fa-external-link" aria-hidden="true"></i>View</a>
                        <a className="action-button" href="/" onClick={goBack}><i className="fa fa-reply-all" aria-hidden="true"></i>Back</a>
                    </span>
                </div>
                <div className="row editor-block">
                    <div className="col-lg-2 col-md-3 treeview-editor">
                        <Treebeard
                            data={trees}
                            onToggle={onToggle}
                            onSelect={onSelect}
                            decorators={{ ...decorators, Header }}
                            customStyles={{
                                header: {
                                    title: {
                                        color: 'red'
                                    }
                                }
                            }}
                        />
                    </div>
                    <div
                        className={`col-lg-10 col-md-9 preview-editor`}
                    >
                        <CodeMirror
                            value={content}
                            autoScroll={false}
                            autoCursor={false}
                            options={{
                                mode: 'javascript',
                                theme: 'monokai',
                            }}
                        />
                    </div>
                </div>
                <ToastContainer
                    position="top-right"
                    autoClose={2000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Page>
        </div>
    );
}

export { Editor };
